import React, { lazy, Suspense } from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Layout from '../layout'

import GuideDetails from '../pages/Guide/GuideDetails'
import Guide from '../pages/Guide/Guide'
import SearchResult from '../pages/SearchResult'
import Epuja from '../pages/Epuja/Epuja'

import EpujaDetails from '../pages/Epuja/EpujaDetails'
import LiveDarshan from '../pages/LiveDarshan/LiveDarshan'
import Blogs from '../pages/Blogs/Blogs'
import BlogDetails from '../pages/Blogs/BlogDetails'

import Profile from '../pages/Profile'
import ProfileDetails from '../pages/Profile/ProfileDetails'
import Bookings from '../pages/Profile/Bookings'
import TopLocation from '../pages/Location/TopLocation'
import LocationDeatials from '../pages/Location/LocationDeatials'

import ToursAndEvents from '../pages/Tours/ToursAndEvents'
import ToursDetails from '../pages/Tours/ToursDetails'
import SingleTourAndEvent from '../pages/Tours/SingleTourAndEvent'
import HomeSearchResult from '../pages/HomeSearchResult'
import Terms from '../pages/Terms'

import HomePage from '../pages/HomePage'
import AccommodationDetails from '../pages/AccomodationDetails'
import Products from '../pages/Ecommerce/Products'
import Cart from '../pages/Ecommerce/Cart'
import ConfirmPay from '../pages/Confirm&Pay'
import Accommodation from '../pages/Accommodation'
import OffersPage from '../pages/OffersPage'


export default () => {
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn)
  const privateRoutes = isLoggedIn ? 
  [{
      path: "/user", element: <Profile />, children: [
        { path: "/user/profile", element: <ProfileDetails /> },
        { path: "/user/bookings", element: <Bookings /> },
      ]
    }] : []
    


  const appRoutes = {
    path: '/', element: <Layout />, children: [
      { path: "/", element: <HomePage /> },
      { path: "/guide", element: <Guide /> },
      { path: "/guide-details/:guideId", element: <GuideDetails /> },

      { path: "/e-puja", element: <Epuja /> },
      { path: "/e-puja-details/:pujaId", element: <EpujaDetails /> },


      { path: "/live-darshan", element: <LiveDarshan /> },
      { path: "/blogs", element: <Blogs /> },
      { path: "/blog-details/:blogId", element: <BlogDetails /> },

      { path: "/offers", element: <OffersPage /> },

      { path: "/search-result", element: <SearchResult /> },
      { path: "/home-search", element: <HomeSearchResult /> },
      { path: "/tours-events", element: <ToursAndEvents /> },
      { path: "/tours-events/:tourId", element: <ToursDetails /> },
      { path: "/tours-events/category", element: <SingleTourAndEvent /> },
      { path: "/accomodation", element: <Accommodation /> },
      { path: "/accomodation-details/:hotelId", element: <AccommodationDetails /> },

      { path: "/products", element: <Products /> },
      { path: "/cart", element: <Cart /> },
      { path: "/confirm-pay", element: <ConfirmPay /> },

      { path: "/top-locations", element: <TopLocation /> },
      { path: "/location-details", element: <LocationDeatials /> },
      { path: "/terms-of-service", element: <Terms title="Terms Of Service"/> },
      { path: "/privacy-policy", element: <Terms title="Privacy Policy"/> },
      { path: "/cookies-policy", element: <Terms title="Cookies Policy"/> },

      ...privateRoutes,

      { path: "/*", element: <Navigate to={'/'} /> }

    ]
  }

  // console.log( 'appRoutes', appRoutes)

  const route = createBrowserRouter([ appRoutes ])
  return (
    <Suspense fallback={<h1>Loading</h1>}>
      <RouterProvider router={route} />
    </Suspense>
  )
}
